import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../analytics";

export default function AnalyticsPageView() {
    const location = useLocation();
    const lastLocation = useRef(null);

    useEffect(() => {
        const key = [location.pathname, location.search, location.hash].join("|");
        if (lastLocation.current === key) return;
        lastLocation.current = key;
        // Defer one tick so route-level document.title updates land first.
        // No cleanup cancellation: StrictMode's double-invoke would cancel the
        // scheduled send and the early-return above would never reschedule it.
        const loc = location;
        setTimeout(() => trackPageView(loc), 0);
    }, [location.pathname, location.search, location.hash]);

    return null;
}
